import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { exportHeaderForXHttpRequest } from './auth.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl = environment.api;

  constructor(private http: HttpClient) { }

  get _apiUrl(): string {
    return this.apiUrl;
  }

  get<T>(path: string, params: any = {}, headers?: HttpHeaders): Observable<T> {
    const options = {
      params: new HttpParams({ fromObject: params }),
      headers
    };
    return this.http.get<T>(`${this.apiUrl}/${path}`, options);
  }

  post<T>(path: string, body: any = {}, headers?: HttpHeaders): Observable<T> {
    console.log('posting', `${this.apiUrl}/${path}`);
    return this.http.post<T>(`${this.apiUrl}/${path}`, body, { headers });
  }

  put<T>(path: string, body: any = {}, headers?: HttpHeaders): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${path}`, body, { headers });
  }

  patch<T>(path: string, body: any = {}, headers?: HttpHeaders): Observable<T> {
    // const httpParams = this.createParams(params);
    return this.http.patch<T>(`${this.apiUrl}/${path}`, body, { headers });
  }


  delete<T>(path: string, headers?: HttpHeaders): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${path}`, { headers });
  }

  upload(path: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/${path}`, formData);
  }

  uploadFormData(path: string, formData: FormData, options?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/${path}`, formData, options);
  }

  makePostRequest<T>(url: string, body: any = {}, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(url, body, { headers });
  }

  makeGetRequest<T>(url: string, headers?: HttpHeaders): Observable<T> {
    return this.http.get<T>(url, { headers });
  }

  makeFormPostRequest<T>(url: string, formData: any): Observable<T> {
    return this.http.post<T>(url, formData);
  }

  private createParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null) {
        httpParams = httpParams.set(key, params[key].toString());
      }
    }
    return httpParams;
  }

  uploadFile(formData: FormData, onProgress?: (progress: number) => void): Observable<any> {
    return this.http.post(`${this.apiUrl}/files/upload`, formData)
    // .pipe(
    //   map(event => {
    //     return event;
    //     // switch (event.type) {
    //     //   case HttpEventType.UploadProgress:
    //     //     if (event.total && onProgress) {
    //     //       const progress = Math.round(100 * event.loaded / event.total);
    //     //       onProgress(progress);
    //     //     }
    //     //     return event;
    //     //   case HttpEventType.Response:
    //     //     return event;
    //     //   default:
    //     //     return event;
    //     // }
    //   })
    // );
  }


  // Hybrid approach: Use XMLHttpRequest for progress, HttpClient for other calls
  uploadFileWithProgress(path: string, formData: FormData, upload: any, onProgress?: (progress: number) => void): Observable<any> {
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();
      
      // Track upload progress
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const percentCompleted = Math.round((event.loaded * 100) / event.total);
          upload.progress = percentCompleted;
          onProgress?.(percentCompleted);
        }
      });
      
      // Handle successful upload
      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            observer.next(response);
            observer.complete();
          } catch (error) {
            observer.error(error);
          }
        } else {
          observer.error(new Error(`Upload failed: ${xhr.status}`));
        }
      });
      
      // Handle errors
      xhr.addEventListener('error', () => {
        observer.error(new Error('Upload failed'));
      });
      
      // Set up request
      xhr.open('POST', `${this.apiUrl}/${path}`);
      const headers = exportHeaderForXHttpRequest();
      Object.entries(headers).forEach(([key, value]) => {
        xhr.setRequestHeader(key, value);
      });
      // Add any other headers you need
      xhr.setRequestHeader('Accept', 'application/json');
      
      // Start upload
      xhr.send(formData);
    });
  }

}
